import {
  FETCH_GGN_PROPRESIS,
  FETCH_GGN_PROPRESI,
  SEARCH_GGN_PROPRESIS,
  FETCHING_GGN_PROPRESIS,
} from '../actions/types';

const INITIAL_STATE = { 
  city:'', 
  fetching:true,
  fetchingRS:true,
  fetchingRR:true,
  propresisMy: [], //list of single user property posted
  propresisRS: [],
  propresisRR: [],
  propresi: null,

  offsetRS: 0,
  offsetRR: 0,

  offsetRRSH: 0,
  offsetRSSH: 0,   //for shortlist

  limitRS: 20,
  limitRR: 20,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case FETCH_GGN_PROPRESIS: 
    return { ...state,
      //propresisRS: Array.from(new Set([...state.propresisRS,...action.payload.propresisRS].map(o => JSON.stringify(o)))).map(str => JSON.parse(str)),
      propresisRS : [...state.propresisRS,...action.payload.propresisRS].filter((o, index, arr) =>
      arr.findIndex(item => JSON.stringify(item) === JSON.stringify(o)) === index),
  
     // propresisRS:[...state.propresisRS,...action.payload.propresisRS] ,
      // propresisRS:removeDup([...state.propresisRS,...action.payload.propresisRS]) ,
     //propresisRR:removeDup([...state.propresisRR,...action.payload.propresisRR]) ,
     limitRS:action.payload.limitRS,
     offsetRS:action.payload.offsetRS,
     countRS:action.payload.countRS,
   };
    case FETCH_GGN_PROPRESI:
      return { ...state, propresi: action.payload };
    
    case SEARCH_GGN_PROPRESIS:
     
      return { ...state, ...action.payload };
    
    case FETCHING_GGN_PROPRESIS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
